import AboutMeFooter from './about-me-footer';

export default AboutMeFooter;
